export default __webpack_public_path__ + "static/logo-f84a900910a03f96e131347b8ef832bd.svg";